import app from "flarum/forum/app";
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from "flarum/common/components/LinkButton";
import SessionDropdown from "flarum/forum/components/SessionDropdown";

/**
 * 个人中心模块
 */
export default function personPageContent() {
  extend(UserPage.prototype, 'onupdate', function () {
    const isLogin = !!app.session.user;

    const likes = document.querySelector('.item-likes');
    const mentions = document.querySelector('.item-mentions');

    const navItems = [likes, mentions];

    for (let i = 0; i < navItems.length; i++) {
      navItems[i].style.display = isLogin ? 'block' : 'none';
    }
  });

  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    const isActor = app.session.user === user;

    if (items.has('mentions')) {
      items.setPriority('mentions', 87);
    }

    if (isActor && app.forum.attribute('canViewFlags')) {
      const count = app.forum.attribute('flagCount');
      items.add(
        'flags',
        <LinkButton href={app.route('user.flags', {username: user?.slug()})} icon="fas fa-flag">
          {app.translator.trans('acme-ruko.forum.user.flag_link')}
          <span className="Button-badge">{count > 0 ? count : ''}</span>
        </LinkButton>,
        85
      );
    }
  });

  extend(SessionDropdown.prototype, 'items', function (items) {
    if (items.has('flamarkt-backoffice')) {
      items.remove('flamarkt-backoffice');
    }

    if (app.forum.attribute('canViewFlags')) {
      const count = app.forum.attribute('flagCount');
      items.add(
        'flags',
        <LinkButton icon="fas fa-flag" href={app.route('user.flags', {username: app.session.user?.slug()})}>
          {app.translator.trans('acme-ruko.forum.header.flag_button')}
          {count !== 0 ? <span className="SessionNotification-unread unread-count">{count}</span> : ""}
        </LinkButton>,
        80
      );
    }
  });
}
